<template>
  <div class="card p-4 shadow-sm">
    <!-- Toast de alerta -->
    <div
      v-if="mostrarToast"
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1055"
    >
      <div class="toast show align-items-center text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i>
            {{ alerta.mensaje }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>

    <!-- Encabezado -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="m-0">Pagos pendientes de empleados</h3>
      <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Pago</button>
    </div>

    <!-- Formulario -->
    <div v-if="mostrarFormulario" class="mb-4">
      <h5 class="mb-3">Nuevo Pago</h5>
      <div class="row g-4">
        <div class="col-md-4">
          <label class="form-label">Nombre</label>
          <input v-model="nuevoPago.Nombre" type="text" class="form-control" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Descripción</label>
          <input v-model="nuevoPago.Descripcion" type="text" class="form-control" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Monto (Q)</label>
          <input v-model.number="nuevoPago.Monto" type="number" min="0.01" step="0.01" class="form-control" />
        </div>
      </div>
      <div class="text-end mt-3">
        <button class="btn btn-primary me-2" @click="guardarPago">Guardar</button>
        <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
      </div>
    </div>

    <!-- Tabla -->
    <div class="table-responsive">
      <table class="table table-bordered text-center align-middle">
        <thead class="table-light">
          <tr>
            <th>Nombre</th>
            <th>Descripción</th>
            <th>Monto</th>
            <th>Fecha</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="pagos.length === 0">
            <td colspan="6">No hay pagos registrados.</td>
          </tr>
          <tr v-for="pago in pagos" :key="pago.IdPagoEmpleado">
            <td>{{ pago.Nombre }}</td>
            <td>{{ pago.Descripcion }}</td>
            <td>Q.{{ Number(pago.Monto).toFixed(2) }}</td>
            <td>{{ pago.Fecha }}</td>
            <td>
              <span class="badge" :class="pago.Estado === 1 ? 'bg-success' : 'bg-warning text-dark'">
                {{ pago.Estado === 1 ? 'Pagado' : 'Pendiente de pagar' }}
              </span>
            </td>
            <td>
              <button
                v-if="pago.Estado === 0"
                class="btn btn-primary btn-sm"
                @click="marcarComoPagado(pago.IdPagoEmpleado)"
              >
                Marcar como Pagado
              </button>
              <span v-else class="text-muted">Sin acciones</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config.js'

export default {
  name: 'PagosEmpleados',
  data() {
    return {
      pagos: [],
      mostrarFormulario: false,
      mostrarToast: false,
      alerta: { mensaje: '', tipo: 'success' },
      nuevoPago: {
        Nombre: '',
        Descripcion: '',
        Monto: ''
      }
    }
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === 'success' ? 'bg-success' : 'bg-danger'
    },
    iconoToast() {
      return this.alerta.tipo === 'success' ? 'bi bi-check-circle' : 'bi bi-exclamation-circle'
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false
    },
    mostrarAlerta(mensaje, tipo = 'success') {
      this.alerta = { mensaje, tipo }
      this.mostrarToast = true
      setTimeout(this.cerrarToast, 3000)
    },
    async obtenerPagos() {
      try {
        const { data } = await axios.get(`${API_URL}/pagosEmpleados`)
        this.pagos = data
      } catch (error) {
        console.error(error)
        this.mostrarAlerta('Error al obtener pagos', 'danger')
      }
    },
    async guardarPago() {
      const { Nombre, Descripcion, Monto } = this.nuevoPago
      if (!Nombre || !Descripcion || !Monto) {
        this.mostrarAlerta('Todos los campos son obligatorios', 'danger')
        return
      }

      try {
        await axios.post(`${API_URL}/pagosEmpleados`, this.nuevoPago)
        this.mostrarAlerta('Pago registrado con éxito')
        this.nuevoPago = { Nombre: '', Descripcion: '', Monto: '' }
        this.mostrarFormulario = false
        this.obtenerPagos()
      } catch (error) {
        console.error(error)
        this.mostrarAlerta('Error al registrar el pago', 'danger')
      }
    },
    async marcarComoPagado(id) {
      try {
        await axios.put(`${API_URL}/pagosEmpleados-pagado/${id}`, { Estado: 1 })
        this.mostrarAlerta('Pago marcado como pagado')
        this.obtenerPagos()
      } catch (error) {
        console.error(error)
        this.mostrarAlerta('Error al actualizar estado', 'danger')
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false
      this.nuevoPago = { Nombre: '', Descripcion: '', Monto: '' }
    }
  },
  mounted() {
    this.obtenerPagos()
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 550px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
